export default "__VITE_ASSET__wVoPHqiS__"